import types from '@/types';

const createControllerModule = (controllerService) => ({
  namespaced: true,
  state: {
    permission: {},
    controllers: [],
  },

  mutations: {
    [types.SET_PERSON_PERMISSION](state, permission) {
      state.permission = permission;
    },
    [types.SET_CONTROLLERS](state, controllers) {
      state.controllers = controllers;
    },
  },

  actions: {
    [types.GET_PERSON_PERMISSION]({ commit }, { controllerId, personId }) {
      return controllerService.getInstanceAction(controllerId, personId)
        .then((response) => {
          commit(types.SET_PERSON_PERMISSION, response.data);
        });
    },
    [types.GET_CONTROLLERS]({ commit }) {
      return controllerService.getSelectOptions()
        .then((response) => {
          commit(types.SET_CONTROLLERS, response.data);
        });
    },
  },
});

export default createControllerModule;



// WEBPACK FOOTER //
// ./src/store/modules/controller.js